// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__MxHJq","sub_container":"MainLayout_sub_container__rYJ+D"};